import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: "0",
}));
